import { render, staticRenderFns } from "./BrachsList.vue?vue&type=template&id=687bae13"
import script from "./BrachsList.vue?vue&type=script&lang=js"
export * from "./BrachsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports